<ng-container
    *ngIf="{
    row: columnData | async,
    selections: isAllSelected | async,
    selected :  selectedRows | async
  } as $"
>
    <ng-container *ngIf="!$.selections && !$.selected!.has(rowIndex)">
        <div *ngIf="!tableAction" (click)="op.toggle($event)" role="button" aria-label="actions-menu-trigger">
            <div class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white">
                <i class="fa fa-ellipsis" aria-hidden="true"></i>
            </div>
            <!-- <div class="mt-1 text-xxs">{{'CLIENT_PROFILE.ACTIONS' | translate}}</div> -->
        </div>

        <p-popover #op styleClass="overflow-hidden" aria-label="prospect-actions-menu">
            <ng-template #content>
                <div class="-mx-4 -my-5">
                    <ul class="list-none ml-0 px-0 text-800 text-left text-sm" role="menu">
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleEditProfileDialog(); op.hide()" role="menuitem" aria-label="edit-profile-action">
                            <i class="fa fa-pencil mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.EDIT_PROFILE' | translate}} </span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="showOpp(); op.hide()" role="menuitem" aria-label="create-opportunity-action">
                            <i class="fa fa-user-plus mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.CREATE_OPPORTUNITY' | translate}}</span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="newTask($.row); op.hide()" role="menuitem" aria-label="create-task-action">
                            <i class="fa fa-list mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.CREATE_TASK' | translate}}</span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="navigateToBillinging($.row); op.hide()" role="menuitem" aria-label="create-subscription-action">
                            <i class="fa fa-plus-circle mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.CREATE_SUBSCRIPTION' | translate}} </span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="op.hide()" role="menuitem" aria-label="charge-fee-action">
                            <i class="fa fa-money-bill mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.CHARGE_A_FEE' | translate}}</span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangePasswordDialog(); op.hide()" role="menuitem" aria-label="change-password-action">
                            <i class="fa fa-lock mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.CHANGE_PASSWORD' | translate}}</span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangeSaleRepDialog(); op.hide()" role="menuitem" aria-label="change-client-rep-action">
                            <i class="fa fa-users mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.CHANGE_CLIENT_REP' | translate}}</span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="attachmentsModal = true; op.hide()" role="menuitem" aria-label="attachments-action">
                            <i class="fa fa-paperclip mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.ATTACHEMENTS' | translate}}</span>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleAssignKeyFobDialog(); op.hide()" role="menuitem" aria-label="assign-key-fob-action">
                            <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.ASSIGN_CHANGE_KEY_FOB' | translate}}</span>
                        </li>
                        <li *ngIf="showDeleteDigitalPass" class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" [ngClass]="{'opacity-40 pointer-events-none': !$.row?.is_digital_keyfob}" (click)="toggleDeleteDigitalKeyFobDialog(); op.hide()" role="menuitem" aria-label="delete-digital-pass-action">
                            <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.DELETE_DIGITAL_PASS' | translate}}</span>
                        </li>
                        <!-- <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="deleteProfileModal = true">
                            <i class="fa fa-user-minus mr-3 text-600"></i>
                            <span>{{'CLIENT_PROFILE.DELETE_ANONYMIZE_PROFILE' | translate}}</span>
                        </li> -->
                        <!-- <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="mergeProfileModal=true">
                            <i class="fa fa-arrows-v mr-3 text-600"></i>
                            <span>{{'CLIENT_PROFILE.MERGE_PROFILE_WITH_OTHER' | translate}}</span>
                        </li> -->
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleBlockClientDialog(); op.hide()" role="menuitem" [attr.aria-label]="$.row?.is_blacklisted ? 'unblock-client-action' : 'block-client-action'">
                            <i class="fa fa-times text-xl-circle mr-3 text-600" aria-hidden="true"></i>
                            <ng-container *ngIf="$.row">
                                <span *ngIf="!$.row?.is_blacklisted">{{'CLIENT_PROFILE.BLOCK_CLIENT' | translate}}</span>
                                <span *ngIf="$.row?.is_blacklisted">{{'CLIENT_PROFILE.UNBLOCK_CLIENT' | translate}}</span>
                            </ng-container>
                        </li>
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" *ngIf="$.row?.client_status.toLowerCase() =='prospect'" (click)="toggleTransferProspectDialog($event); op.hide()" role="menuitem" aria-label="transfer-prospect-action">
                            <i class="fa fa-exchange-alt mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.TRANSFER_PROSPECT' | translate}}</span>
                        </li>
                    </ul>
                </div>
            </ng-template>
        </p-popover>

        <div class="text-right" *ngIf="tableAction">
            <button
                pButton
                pRipple
                type="button"
                icon="fa fa-angle-down"
                label="{{'CLIENT_PROFILE.ACTIONS' | translate}}"
                iconPos="right"
                class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
                (click)="action.toggle($event)"
                aria-label="prospect-actions-button"
            ></button>
        </div>
        <p-popover #action styleClass="overflow-hidden text-sm w-17rem" aria-label="prospect-actions-menu">
            <ng-template #content>
                <ul class="list-none -mx-4 -my-3 px-0 text-xs text-600" role="menu">
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleEditProfileDialog(); action.hide()" role="menuitem" aria-label="edit-profile-action">
                        <i class="fa fa-pencil mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.EDIT_PROFILE' | translate}} </span>
                    </li>
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="showOpp(); action.hide()" role="menuitem" aria-label="create-opportunity-action">
                        <i class="fa fa-user-plus mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.CREATE_OPPORTUNITY' | translate}}</span>
                    </li>
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="newTask($.row); action.hide()" role="menuitem" aria-label="create-task-action">
                        <i class="fa fa-list mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.CREATE_TASK' | translate}}</span>
                    </li>
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="navigateToBillinging($.row); action.hide()" role="menuitem" aria-label="create-subscription-action">
                        <i class="fa fa-plus-circle mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.CREATE_SUBSCRIPTION' | translate}}</span>
                    </li>
                    <!-- <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer">
                       <i class="fa fa-money-bill mr-3 text-600"></i>
                      <span>{{'CLIENT_PROFILE.CHARGE_A_FEE' | translate}}</span>
                    </li> -->
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangePasswordDialog(); action.hide()" role="menuitem" aria-label="change-password-action">
                        <i class="fa fa-lock mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.CHANGE_PASSWORD' | translate}}</span>
                    </li>
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangeSaleRepDialog(); action.hide()" role="menuitem" aria-label="change-sales-rep-action">
                        <i class="fa fa-users mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.CHANGE_SALES_REP' | translate}}</span>
                    </li>
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="attachmentsModal = true; action.hide()" role="menuitem" aria-label="attachments-action">
                        <i class="fa fa-paperclip mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.ATTACHEMENTS' | translate}}</span>
                    </li>
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleAssignKeyFobDialog(); action.hide()" role="menuitem" aria-label="assign-key-fob-action">
                        <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.ASSIGN_CHANGE_KEY_FOB' | translate}}</span>
                    </li>
                    <li *ngIf="showDeleteDigitalPass" class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleDeleteDigitalKeyFobDialog(); action.hide()" role="menuitem" aria-label="delete-digital-pass-action">
                        <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                        <span>{{'CLIENT_PROFILE.DELETE_DIGITAL_PASS' | translate}}</span>
                    </li>
                    <!-- <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer"
                        (click)="deleteProfileModal = true">
                        <i class="fa fa-user-minus mr-3 text-600"></i>
                        <span>{{'CLIENT_PROFILE.DELETE_ANONYMIZE_PROFILE' | translate}}</span>
                        </li> -->
                       <!-- <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer"
                        (click)="mergeProfileModal=true">
                        <i class="fa fa-arrows-v mr-3 text-600"></i>
                        <span>{{'CLIENT_PROFILE.MERGE_PROFILE_WITH_OTHER' | translate}}</span>
                    </li> -->
                    <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" *ngIf="$.row?.client_status =='Client' || $.row?.client_status =='ClientNonMember'" (click)="toggleBlockClientDialog(); action.hide()" role="menuitem" [attr.aria-label]="$.row?.is_blacklisted ? 'unblock-client-action' : 'block-client-action'">
                        <i class="fa fa-times-circle mr-3 text-600" aria-hidden="true"></i>
                        <ng-container *ngIf="$.row">
                            <span *ngIf="!$.row?.is_blacklisted">{{'CLIENT_PROFILE.BLOCK_CLIENT' | translate}}</span>
                            <span *ngIf="$.row?.is_blacklisted">{{'CLIENT_PROFILE.UNBLOCK_CLIENT' | translate}}</span>
                        </ng-container>
                    </li>
                </ul>
            </ng-template>
        </p-popover>
    </ng-container>

    <!-- <edit-profile *ngIf="toggleEditProfileDialog$ | async" [editProfileModal]="toggleEditProfileDialog$ | async" [clientData$]="columnData" (closeEditProfileDialog)="closeEditProfile($event)"> </edit-profile> -->

    <create-client-profile-sidebar *ngIf="toggleEditProfileDialog$ | async as showPopup" [showProspect]="showPopup"  [clientData]="colData" [formType]="'prospect'" [formEvent]="'update'"
     (closeEditProfile)="closeEditProfile($event)" aria-label="edit-profile-sidebar">
    </create-client-profile-sidebar>

    <client-profile-change-password
        *ngIf="toggleChangePasswordDialog$ | async"
        [changePasswordModal]="toggleChangePasswordDialog$ | async"
        [clientDetails]="(columnData | async)"
        (closePopup)="closeChangePasswordDialog($event)"
        [tenantId]="tenantId"
        aria-label="change-password-dialog"
    >
    </client-profile-change-password>

    <!-- Assign Key FOB Modal  -->
    <assign-key-fob *ngIf="toggleAssignKeyFobDialog$ | async" [assignKeyFobModal]="toggleAssignKeyFobDialog$ | async" [clientId]="(columnData | async)?.id" (closeassignKeyFobModalDialog)="closeAssignKeyFob($event)" aria-label="assign-key-fob-dialog"> </assign-key-fob>
    <!-- Assign Key FOB Modal -->

    <!-- Block Profile Modal  -->
    <block-client *ngIf="toggleBlockClientDialog$ | async" [blockClientModal]="toggleBlockClientDialog$ | async" [clientData$]="columnData" (closeBlockClientDialog)="closeBlockClientDialog($event)" aria-label="block-client-dialog"> </block-client>

    <!-- Block Profile Modal -->

    <delete-digital-pass *ngIf="toggleDeleteDigitalKeyFobDialog$ | async" [deleteDigitalPassModal]="toggleDeleteDigitalKeyFobDialog$ | async" [clientData$]="columnData" (closeDeleteDigitalPassDialog)="closeDeleteDigitalPassDialog($event)" aria-label="delete-digital-pass-dialog"> </delete-digital-pass>

    <!-- Change Sales Rep Modal  -->
    <change-sales-representative *ngIf="toggleChangeSaleRepDialog$ | async" [changeRepresentativeModal]="toggleChangeSaleRepDialog$ | async" [clientData$]="columnData" (closeChangeRepresentativeDialog)="closeChangeSaleRepDialog($event)" aria-label="change-sales-rep-dialog">
    </change-sales-representative>
    <!-- Change Sales Rep Modal  -->

    <!-- Transfer Prospect Modal  -->
    <transfer-prospect *ngIf="toggleTransferProspectDialog$ | async" [transferProspectModal]="toggleTransferProspectDialog$ | async" [clientData$]="columnData" (closeTransferProspectDialog)="closeTransferProspectDialog($event)" aria-label="transfer-prospect-dialog">
    </transfer-prospect>
    <!-- Transfer Prospect Modal  -->

    <create-opportunity *ngIf="showCreateOpportunityPopup" [visible]="showCreateOpportunityPopup" [clientInfo]="clientDetails" (hidePopup)="hideOpportunity($event)" aria-label="create-opportunity-dialog"> </create-opportunity>

    <task-create *ngIf="showTaskCreate" [visible]="showTaskCreate" [cltIds]="clientIds" (closeTaskPopup)="HideTaskCreate($event)" aria-label="create-task-dialog"> </task-create>

    <!-- <billing-summary *ngIf="showPaidFullSidebar" [visible]="showPaidFullSidebar" [planSummarydata]="planSummarydataObject"
      (hideSidePopup)="HideBillingSummary($event)" closeOnEscape="false">

    </billing-summary> -->

    <!--NOT COVERED ON THIS SPRINT-->
    <attachments *ngIf="attachmentsModal" [attachmentsModal]="attachmentsModal" (close)="closeAttachmentDialog($event)" [clientId]="selectedClient.get('id').id" [tenantId]="tenantId" (close)="closeAttachmentDialog($event)" aria-label="attachments-dialog"> </attachments>

   
</ng-container>